var exports = {
  "kL": "xe533113f--008a5a--container",
  "Kk": "xe533113f--008a5a--icon",
  "UU": "xe533113f--008a5a--name",
};

module.exports = exports;
